import React from 'react';
import './styles.css';

const HowItWorks = () => {
  return (
    <section className="how-it-works-section">
      <div className="container">
        <div className="how-it-works-header" data-aos="fade-up">
          <div className="section-badge">How It Works</div>
          <h3 className="section-title">Your Learning Journey in 4 Simple Steps</h3>
          <p className="section-subtitle">
            Get started with personalized AI-powered learning in minutes
          </p>
        </div>

        <div className="steps-snake-container">
          <div className="step-row step-row-right" data-aos="fade-right" data-aos-delay="100">
            <div className="step-content">
              <div className="step-badge">1</div>
              <h4 className="step-title">Choose Your Subject</h4>
              <p className="step-description">
                Select the subject and topics you want to practice from our comprehensive coverage of academic subjects
              </p>
              <div className="feature-pill">
                <svg className="feature-pill-icon" viewBox="0 0 24 24" width="10" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                </svg>
                <span>Comprehensive coverage of all academic subjects</span>
              </div>
            </div>
            <div className="step-image">
              <div className="step-illustration">
                <svg viewBox="0 0 24 24" width="50" height="50" fill="none" stroke="#4361EE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                  <line x1="12" y1="6" x2="12" y2="10"></line>
                  <line x1="10" y1="8" x2="14" y2="8"></line>
                </svg>
              </div>
            </div>
          </div>
          
          {/* Step 2 - Right aligned */}
          <div className="step-row step-row-left" data-aos="fade-left" data-aos-delay="200">
            <div className="step-image">
              <div className="step-illustration">
                <svg viewBox="0 0 24 24" width="50" height="50" fill="none" stroke="#FF6A3D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="8" r="5"></circle>
                  <path d="M20 21v-2a7 7 0 0 0-14 0v2"></path>
                  <line x1="12" y1="13" x2="12" y2="16"></line>
                  <line x1="8" y1="17" x2="16" y2="17"></line>
                </svg>
              </div>
            </div>
            <div className="step-content">
              <div className="step-badge">2</div>
              <h4 className="step-title">Meet Your AI Teacher</h4>
              <p className="step-description">
                Connect with your subject-specific AI teacher who adapts to your unique learning style and needs
              </p>
              <div className="feature-pill">
                <svg className="feature-pill-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <span>Personalized teaching approach</span>
              </div>
            </div>
          </div>
   
          <div className="step-row step-row-right" data-aos="fade-right" data-aos-delay="300">
            <div className="step-content">
              <div className="step-badge">3</div>
              <h4 className="step-title">Practice & Get Feedback</h4>
              <p className="step-description">
                Work through practice problems and submit your answers for immediate, detailed feedback and guidance
              </p>
              <div className="feature-pill">
                <svg className="feature-pill-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M13 2L3 14 12 14 11 22 21 10 12 10 13 2z"></path>
                </svg>
                <span>Instant feedback on all answer types</span>
              </div>
            </div>
            <div className="step-image">
              <div className="step-illustration">
                <svg viewBox="0 0 24 24" width="50" height="50" fill="none" stroke="#4361EE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <path d="M14 2v6h6"></path>
                  <path d="M9 13h6"></path>
                  <path d="M9 17h6"></path>
                  <path d="M9 9h1"></path>
                </svg>
              </div>
            </div>
          </div>
     
          <div className="step-row step-row-left" data-aos="fade-left" data-aos-delay="400">
            <div className="step-image">
              <div className="step-illustration">
                <svg viewBox="0 0 24 24" width="50" height="50" fill="none" stroke="#FF6A3D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 3v18h18"></path>
                  <path d="m18.4 8-5.4-5.4-5.4 5.4"></path>
                  <path d="m6.6 16 5.4-5.4 5.4 5.4"></path>
                  <circle cx="8.5" cy="8.5" r="1.5" fill="#FF6A3D"></circle>
                  <circle cx="15.5" cy="15.5" r="1.5" fill="#FF6A3D"></circle>
                </svg>
              </div>
            </div>
            <div className="step-content">
              <div className="step-badge">4</div>
              <h4 className="step-title">Track Your Progress</h4>
              <p className="step-description">
                Monitor your learning journey with visual analytics that highlight strengths and areas for improvement
              </p>
              <div className="feature-pill">
                <svg className="feature-pill-icon" viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 3v18h18"></path>
                  <path d="m18.4 8-5.4-5.4-5.4 5.4"></path>
                  <path d="m6.6 16 5.4-5.4 5.4 5.4"></path>
                </svg>
                <span>Visual progress tracking and insights</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
